import { type DownloadDocumentHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/downloadDocumentHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

export const downloadDocumentNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): DownloadDocumentHandlerSchema['nodeData']['payload'] => {
  const assignToRequester =
    typeof payload.assign_to_requester === 'boolean' ? payload.assign_to_requester : false
  const assigneeIds = Array.isArray(payload.assignee_ids) ? payload.assignee_ids : []

  // If assign_to_requester is true, add 'purchase_requester' to assignee_ids
  // so it shows up as selected in the EntitySelect component
  const assigneeIdsWithRequester = assignToRequester
    ? [...assigneeIds, 'purchase_requester']
    : assigneeIds

  // Return undefined if empty to match optional type, otherwise return the array
  const finalAssigneeIds =
    assigneeIdsWithRequester.length > 0 ? assigneeIdsWithRequester : undefined

  const due_on_value = payload.due_on_value
  const numericDueOnValue =
    typeof due_on_value === 'number' && !isNaN(due_on_value) ? due_on_value : 2

  const due_on_unit = String(payload.due_on_unit)

  // Handle files - preserve workflow_node_files_ids if present, otherwise use files
  const workflowNodeFilesIds = Array.isArray(payload.workflow_node_files_ids)
    ? payload.workflow_node_files_ids
    : undefined
  const files = Array.isArray(payload.files) ? payload.files : []

  return {
    title: typeof payload.title === 'string' ? payload.title : '',
    description: typeof payload.description === 'string' ? payload.description : '',
    assign_to_requester: assignToRequester,
    assignee_ids: finalAssigneeIds,
    files: files,
    workflow_node_files_ids: workflowNodeFilesIds,
    due_on_unit: isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT,
    due_on_value: numericDueOnValue,
  }
}
